var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3785_11670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0071 31.6128L56.0796 51.5174V69.3114L74.9797 50.378L93.7782 31.6128H75.0071Z",
    fill: "url(#paint0_linear_3785_11670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0796 69.3115L74.9797 50.3782L93.7782 69.3115H56.0796Z",
    fill: "url(#paint1_linear_3785_11670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0796 31.6128H75.0071L56.0796 51.5174V31.6128Z",
    fill: "url(#paint2_linear_3785_11670)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3785_11670",
    x1: 49.7327,
    y1: 66.2728,
    x2: 84.8131,
    y2: 31.1921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#C757BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#CD5CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#E8744F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#F88316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3785_11670",
    x1: 68.111,
    y1: 76.113,
    x2: 85.2099,
    y2: 59.0139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3785_11670",
    x1: 23.9217,
    y1: 928.196,
    x2: 918.854,
    y2: 77.1951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3785_11670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.8947,
    height: 40,
    fill: "white",
    transform: "translate(56.002 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.9cd7a2f21ff512f94413bc53537544d1.svg";
export { ForwardRef as ReactComponent };